/*
 * @Author: 宋乾
 * @Date: 2019-10-17 14:02:54
 * @Last Modified by: 宋乾
 * @Last Modified time: 2020-06-11 14:20:55
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// 运行命令 tsc src/IGC_JS2Native/index.ts -d -t es2017
import { env } from '../env/index';
import { compareVersion } from '../semver';
import { defaults, isH5ProdEnv, Log } from '../common';
var SUCCESS_MESSAGE = '成功';
var ERROR_MESSAGE = '失败';
var SUCCESS_CODE = 0;
var ERROR_CODE = -1;
/**
 * 进群小程序 正式
 * 名字：少年得到活动
 * APPID: wx4cc93883173e26f2
 * 原始ID: gh_3451c0ee7477
 *
 * 进群小程序 测试
 * 名字：少年得到跨年礼
 * APPID: wx84a9d271adb1ce25
 * 原始ID: gh_d8e232338b23
 *
 * 唤起小程序使用原始 ID
 */
var WX_MINI_APP_ORIGIN_ID = isH5ProdEnv() ? 'gh_3451c0ee7477' : 'gh_d8e232338b23';
// 全局注入 IGC_Native2Js
window.IGC_Native2Js = function (data) {
    var params = JSON.parse(data);
    window[params.name] && window[params.name](params.params || {});
};
var postMessageToNative = function (params) {
    return function () {
        if (env.isAndroidApp) {
            // 安卓注入方式
            window.DDAppWebView.IGC_Js2Native(JSON.stringify(params));
        }
        else {
            // ios注入方式
            window.webkit.messageHandlers.IGC_JS2Native.postMessage(params);
        }
    };
};
// 消息存储
var MessageQueue = {};
// 新版本支持透传id
var MessageQueueV2 = {};
// IGC_NativeCallBack 是个对象
if (!window.IGC_NativeCallBack) {
    window.IGC_NativeCallBack = {};
}
// ua
var ua = window.navigator.userAgent;
// 如果是少年得到app
if (/JuvenileGet/i.test(ua)) {
    var newAppRegExp = /AppVersion=([\d.]+)/;
    var matches = ua.match(newAppRegExp);
    var appVer = '';
    if (matches) {
        appVer = matches[1];
    }
    // 版本大于等于2.8.5，才有新的函数
    if (appVer) {
        var v285 = compareVersion(appVer, '2.8.5');
        // 原本定于375版本，因为人力占用一直没发版
        var v375 = compareVersion(appVer, '3.7.5');
        if (v285 >= 0 && v375 < 0) {
            // if (v285 >= 0) {
            // 全局注入 IGC_JS2Native_V2
            window.IGC_JS2Native_V2 = function (args) {
                var _a, _b, _c;
                // create message
                var channel = new MessageChannel();
                // 客户端的回调
                window.IGC_NativeCallBack[args.name] = function (nativeValue) {
                    var _a, _b, _c, _d, _e;
                    if ((_b = (_a = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _a === void 0 ? void 0 : _a.handle) === null || _b === void 0 ? void 0 : _b[0]) {
                        MessageQueue[args.name].handle[0].channel.port1.postMessage(nativeValue);
                        MessageQueue[args.name].handle.splice(0, 1);
                    }
                    else {
                        channel === null || channel === void 0 ? void 0 : channel.port1.postMessage(nativeValue);
                    }
                    if (!((_d = (_c = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _c === void 0 ? void 0 : _c.handle) === null || _d === void 0 ? void 0 : _d.length) && typeof ((_e = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _e === void 0 ? void 0 : _e.running) === 'boolean') {
                        MessageQueue[args.name].running = false;
                    }
                };
                var message = postMessageToNative(args);
                // 需要队列支持的异步方法
                if (['doRequest', 'checkDeviceAuth', 'getUserInfo', 'wXPay'].includes(args.name)) {
                    if (!MessageQueue[args.name]) {
                        MessageQueue[args.name] = {
                            handle: [],
                            running: false,
                        };
                    }
                    MessageQueue[args.name].handle.push({
                        channel: channel,
                        message: message,
                    });
                }
                else {
                    // 其他直接执行
                    message();
                }
                if (((_b = (_a = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _a === void 0 ? void 0 : _a.handle) === null || _b === void 0 ? void 0 : _b[0]) && !((_c = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _c === void 0 ? void 0 : _c.running)) {
                    MessageQueue[args.name].handle[0].message();
                    MessageQueue[args.name].running = true;
                }
                return new Promise(function (resolve) {
                    if (channel) {
                        channel.port2.onmessage = function (e) {
                            var _a, _b, _c;
                            var data = e.data;
                            (_c = (_b = (_a = MessageQueue === null || MessageQueue === void 0 ? void 0 : MessageQueue[args.name]) === null || _a === void 0 ? void 0 : _a.handle) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message();
                            channel = null;
                            resolve(data);
                        };
                    }
                });
            };
        }
        else if (v375 >= 0) {
            // 全局注入 IGC_JS2Native
            window.IGC_JS2Native_V2 = function (args) {
                // create message
                var channel = new MessageChannel();
                // 唯一的id值
                var id = args.name + "_" + Math.random();
                // 传递给客户端
                args.params = args.params || {};
                args.params.id = id;
                // 消息存储
                MessageQueueV2[id] = channel;
                // 客户端的回调
                window.IGC_NativeCallBack[args.name] = function (nativeValue) {
                    var _a;
                    var _id = (_a = nativeValue === null || nativeValue === void 0 ? void 0 : nativeValue.params) === null || _a === void 0 ? void 0 : _a.id;
                    if (_id && MessageQueueV2[_id]) {
                        MessageQueueV2[_id].port1.postMessage(nativeValue);
                        delete MessageQueueV2[_id];
                    }
                    else {
                        // App 375+ 版后，返回的 nativeValue 必须要有传入的 params，
                        // 这样 JS 才可以保证回调的顺序问题，否则会出现并发请求覆盖上一个的问题。
                        Log.error("\u56DE\u8C03\u51FD\u6570 " + args.name + " \u9700\u8981\u8FD4\u56DE params");
                    }
                };
                postMessageToNative(args)();
                return new Promise(function (resolve) {
                    if (channel) {
                        channel.port2.onmessage = function (e) {
                            var data = e.data;
                            channel = null;
                            resolve(data);
                        };
                    }
                });
            };
        }
    }
}
/**
 * 格式化数据格式化，维护老数据
 */
var initParams = {
    doGet: function (params) {
        return [params.url, params.data];
    },
    doPost: function (params) {
        return [params.url, params.data];
    },
    showToast: function (params) {
        return [params.content];
    },
    setPageTitle: function (params) {
        return [params.title];
    },
    navigateTo: function (params) {
        return [params.router, 'navigateToErr'];
    },
    showImagesBrowser: function (params) {
        params.images = params.images.map(function (item) {
            return {
                mImageUrl: item,
            };
        });
        return [JSON.stringify(params)];
    },
    playMusic: function (params) {
        return [params.dataForApp, params.code];
    },
    pauseMusic: function () {
        return [];
    },
    mediaControl: function (params) {
        if (params.method === 'play') {
            return [
                params.dataForApp,
                params.code,
            ];
        }
        return [];
    },
    notify: function (params) {
        return [params.name];
    },
    webShare: function (params) {
        /**
         * 老数据格式为：WXFRIEND-WXPYQ-QQ-QZONE-WB
         */
        var channel = params.channel ? params.channel.join('-') : '';
        return [params.event, channel, 'web', JSON.stringify(params.shareInfo)];
    },
    doLogin: function (params) {
        return [params.type];
    }
};
/**
 * 格式化返回值，维护老数据
 */
var initResult = {
    checkMusicStateCallBack: function (audioPid, isPlaying) {
        return {
            audioPid: audioPid,
            isPlaying: isPlaying,
        };
    },
    doLogin: function (pid) {
        return {
            pid: pid,
        };
    }
};
/**
 * 老版本的函数
 */
var NativeFunction = function (name) {
    var _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var data = null;
    if (window.DDAppWebView && window.DDAppWebView[name]) {
        data = (_a = window.DDAppWebView)[name].apply(_a, args);
    }
    else if (window[name]) {
        data = window[name].apply(window, args);
    }
    else {
        data = null;
    }
    return data;
};
/**
 * random 获取随机数
 * @param { number } min 最小值
 * @param { number } max 最大值
 */
var random = function (min, max) {
    var num = Math.floor(Math.random() * (min - max) + max);
    return num;
};
/**
 * 格式化json字符串
 * @param { string } res
 */
var stringToJson = function (res) {
    var json = {};
    if (typeof res === 'string') {
        json = JSON.parse(res);
    }
    else {
        json = res;
    }
    return json;
};
/**
 * 获取用户id，避免游客模式干扰
 */
export var getAppUserPid = function () {
    return new Promise(function (resolve) {
        if (!!window.IGC_JS2Native_V2) {
            JS2Native({ name: 'getUserInfo' }).then(function (res) {
                if (res.code === 0) {
                    if (Object.prototype.toString.call(res.data) === '[object Object]') {
                        var json = res.data;
                        var isLogin = json['isLogin'];
                        var pid = json['App-User-Pid'];
                        resolve({
                            code: isLogin ? SUCCESS_CODE : ERROR_CODE,
                            msg: isLogin ? SUCCESS_MESSAGE : ERROR_MESSAGE,
                            data: isLogin ? pid : null,
                        });
                    }
                    else {
                        resolve({
                            code: ERROR_CODE,
                            msg: ERROR_MESSAGE,
                            data: null,
                        });
                    }
                }
                else {
                    resolve({
                        code: ERROR_CODE,
                        msg: ERROR_MESSAGE,
                        data: null,
                    });
                }
            });
        }
        else {
            JS2Native({
                name: 'doRequest',
                params: {
                    method: 'get',
                    url: 'app-api-user-server/oath/user/info.json'
                }
            }).then(function (_a) {
                var data = _a.data;
                if (data.code === 10000) {
                    resolve({
                        code: SUCCESS_CODE,
                        msg: SUCCESS_MESSAGE,
                        data: data.data.pid
                    });
                }
                else {
                    resolve({
                        code: ERROR_CODE,
                        msg: ERROR_MESSAGE,
                        data: null,
                    });
                }
            }).catch(function () {
                resolve({
                    code: ERROR_CODE,
                    msg: ERROR_MESSAGE,
                    data: null,
                });
            });
        }
    });
};
/**
 * 获取跳转登录地址
 * type: page、window
 */
export var getLoginUrl = function (type, data) {
    if (data === void 0) { data = {}; }
    var arr = [];
    for (var key in data) {
        var value = data[key];
        arr.push(key + "=" + value);
    }
    var url = "igetcool://juvenile.dedao.passport/passport/v2/login?" + (env.isAndroidApp ? 'params_type=20000&params_status=login_status' : 'isLastPage=0');
    if (type === 'window') {
        url = "igetcool://juvenile.dedao.passport/passport/quick/login?" + arr.join('&');
    }
    return url;
};
/**
 * 销货所有音频，之前ios的bug
 */
var doDestroyAllAudio = function () {
    window.destroyAllAudio = function () {
        var audios = document.getElementsByTagName('audio');
        while (audios.length) {
            if (audios && audios[0] && audios[0].parentNode) {
                audios[0].parentNode.removeChild(audios[0]);
            }
        }
    };
};
/**
 * initParamsName 获取name
 */
var initParamsName = function (params) {
    var name = params.name;
    if (name === 'doRequest') {
        var method = params.params.method;
        switch (method) {
            case 'get':
                name = 'doGet';
                break;
            case 'post':
                name = 'doPost';
                break;
        }
    }
    else if (name === 'mediaControl') {
        var method = params.params.method;
        switch (method) {
            case 'play':
                name = 'playMusic';
                break;
            case 'pause':
                name = 'pauseMusic';
                break;
        }
    }
    else if (name === 'getUserInfo') {
        name = 'onAuth';
    }
    return name;
};
/**
 * 设置默认的 params 属性
 * 补充一些默认的数据，以防业务调用时漏加。如果业务里传入，则默认不生效。
 */
var setDefaultParams = function (_params) {
    var _a = _params, name = _a.name, _b = _a.params, params = _b === void 0 ? {} : _b;
    var defaultParams = {};
    switch (name) {
        case 'webShare':
            defaultParams = {
                event: 'sndd_app_traffic'
            };
            params.shareInfo = defaults(params.shareInfo, {
                hostAndPath: location.href
            });
            break;
        case 'screenShot':
            params.shareInfo = defaults(params.shareInfo, {
                hostAndPath: location.href
            });
            break;
        case 'goToMiniProgram':
            // 根据域名判断使用哪个小程序，如果传入 appId，则使用传入的
            defaultParams = {
                appId: WX_MINI_APP_ORIGIN_ID
            };
            break;
        case 'setReferInfo':
            defaultParams = {
                refer_page_name: window.refer_page_name || '未知页面',
                refer_url: location.href
            };
            break;
    }
    _params.params = defaults(params, defaultParams);
    return _params;
};
var doLoginTimer = null; // 跳转登录防抖
/**
 * igetcool 重写方法
 */
export var igetcool = {
    /**
     * doRequest 原生请求
     * @param { string } url 请求地址
     * @param { object } params 参数
     * @param { string } code 未知
     */
    doRequest: function (name, url, params, code) {
        if (params === void 0) { params = {}; }
        if (code === void 0) { code = '0'; }
        // 返回Promise
        return new Promise(function (resolve, reject) {
            // 生成成功与失败随机函数
            var number = random(1, 10000);
            var date = +new Date();
            var successFunction = "successFunction_" + number + date;
            var errorFunction = "errorFunction_" + number + date;
            // 格式化data数据
            var data = {
                params: [],
                path: '',
                successFunction: '',
                errorFunction: '',
            };
            // json => array
            var array = [];
            // 如果是数组，维护老数据
            if (Array.isArray(params)) {
                array = __spreadArrays(params);
            }
            else {
                for (var key in params) {
                    var value = params[key];
                    array.push({ key: key, value: value });
                }
            }
            // 设置参数
            data.params = array;
            // 设置url
            data.path = url;
            // 成功回调
            data.successFunction = successFunction;
            data.errorFunction = errorFunction;
            window[successFunction] = function (res) {
                resolve({
                    code: SUCCESS_CODE,
                    data: stringToJson(res),
                    msg: SUCCESS_MESSAGE,
                });
                window[successFunction] = null;
            };
            // 失败回调
            window[errorFunction] = function (res) {
                reject({
                    code: ERROR_CODE,
                    data: stringToJson(res),
                    msg: ERROR_MESSAGE,
                });
                window[errorFunction] = null;
            };
            // 序列化参数
            var arg = JSON.stringify(data);
            // 调用原生方法
            NativeFunction(name, arg, code);
        });
    },
    /**
     * doLogin 登录方法
     * type: 窗口类型
     */
    doLogin: function (type) {
        if (type === void 0) { type = 'page'; }
        return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAppUserPid()];
                    case 1:
                        data = (_a.sent()).data;
                        if (data) {
                            return [2 /*return*/, resolve({ code: SUCCESS_CODE, msg: SUCCESS_MESSAGE, data: data })];
                        }
                        if (doLoginTimer !== null) {
                            clearTimeout(doLoginTimer);
                        }
                        doLoginTimer = setTimeout(function () {
                            // 跳转
                            JS2Native({
                                name: 'navigateTo',
                                params: {
                                    router: getLoginUrl(type),
                                }
                            }).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                                var data_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(res.code === 0)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, getAppUserPid()];
                                        case 1:
                                            data_1 = (_a.sent()).data;
                                            // 回调
                                            resolve({ code: SUCCESS_CODE, msg: SUCCESS_MESSAGE, data: data_1 });
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }, 500);
                        return [2 /*return*/];
                }
            });
        }); });
    },
    /**
     * 原生跳转
     * router：路由地址
     */
    navigateTo: function (router) {
        return new Promise(function (resolve) {
            // 页面返回触发的回调
            Native2Js({
                name: 'onPageResume',
            }, function () {
                // 回调
                resolve({ code: SUCCESS_CODE, msg: SUCCESS_MESSAGE, data: null });
                window.navigateToErr = null;
            });
            // 兼容老数据
            doDestroyAllAudio();
            // 单独处理一下跳转
            if (window.IGC_JS2Native_V2) {
                window.IGC_JS2Native_V2({
                    name: 'navigateTo',
                    params: {
                        router: router,
                    },
                });
            }
            else {
                window.navigateToErr = function () {
                };
                NativeFunction('navigateTo', router, 'navigateToErr');
            }
        });
    },
    /**
     * 原生跳转 由于之前的跳转不允许传递别的参数 因此新写一个方法 来传递多余的参数
     * router：路由地址
     */
    navigateToParams: function (data) {
        return new Promise(function (resolve) {
            // 页面返回触发的回调
            Native2Js({
                name: 'onPageResume',
            }, function () {
                // 回调
                resolve({ code: SUCCESS_CODE, msg: SUCCESS_MESSAGE, data: null });
                window.navigateToErr = null;
            });
            // 兼容老数据
            doDestroyAllAudio();
            // 单独处理一下跳转
            if (window.IGC_JS2Native_V2) {
                window.IGC_JS2Native_V2({
                    name: 'navigateTo',
                    params: __assign({}, data),
                });
            }
            else {
                window.navigateToErr = function () {
                };
                NativeFunction('navigateTo', data.router, 'navigateToErr');
            }
        });
    },
    // 设置referInfo
    setReferInfo: function (params) {
        return new Promise(function (resolve) {
            if (window.IGC_JS2Native_V2) {
                window.IGC_JS2Native_V2({
                    name: 'setReferInfo',
                    params: params,
                }).then(function (result) {
                    resolve(result);
                });
            }
            else {
                // 老版本不存在，直接返回错误 code码
                resolve({ code: ERROR_CODE, data: null, msg: ERROR_MESSAGE });
            }
        });
    },
    /**
     * 截屏，需要延迟处理，因为需要隐藏按钮
     */
    screenShot: function (params) {
        return new Promise(function (resolve) {
            if (window.IGC_JS2Native_V2) {
                setTimeout(function () {
                    window.IGC_JS2Native_V2({
                        name: 'screenShot',
                        params: params,
                    }).then(function (result) {
                        resolve(result);
                    });
                }, 100);
            }
            else {
                // 老版本不存在，直接返回错误 code码
                resolve({ code: ERROR_CODE, data: null, msg: ERROR_MESSAGE });
            }
        });
    },
};
// js 调用native
export var JS2Native = function (params) {
    var _a, _b;
    if (!env.isApp)
        return new Promise(function (resolve) {
            resolve({ code: ERROR_CODE, data: null, msg: ERROR_MESSAGE });
        });
    params = setDefaultParams(params);
    // 这几个纯前端方法
    if (params.name === 'doLogin') {
        return igetcool.doLogin((_a = params.params) === null || _a === void 0 ? void 0 : _a['type']);
    }
    else if (params.name === 'navigateTo') {
        return igetcool.navigateTo((_b = params.params) === null || _b === void 0 ? void 0 : _b['router']);
    }
    else if (params.name === 'navigateToParams') {
        return igetcool.navigateToParams(params.params);
    }
    else if (params.name === 'getAppUserPid') {
        // 获取用户pid
        return getAppUserPid();
    }
    else if (params.name === 'screenShot') {
        return igetcool.screenShot(params.params);
    }
    else if (params.name === 'setReferInfo') {
        return igetcool.setReferInfo(params.params);
    }
    // 存在新方法就使用新方法
    if (window.IGC_JS2Native_V2) {
        return window.IGC_JS2Native_V2(params);
    }
    // 以下为老版本
    // 获取调用的方法名称
    var name = initParamsName(params);
    // 旧方法需要格式化数据
    var arg = initParams[name] ? initParams[name](params.params) : [];
    // 老版本的请求，由前端模拟新版本格式完成
    if (name === 'doGet' || name === 'doPost') {
        // 处理get、post类型，新版本为doRequest
        return igetcool.doRequest(name, arg[0], arg[1]);
    }
    else {
        // 其他走默认旧方法
        return new Promise(function (resolve) {
            var data = NativeFunction.apply(void 0, __spreadArrays([name], arg));
            // 这是一个json字符串数据
            if (name === 'onAuth') {
                data = stringToJson(data);
            }
            resolve({ code: SUCCESS_CODE, data: data, msg: SUCCESS_MESSAGE });
        });
    }
};
// 存放回调的对象
var Native2JsCallBack = {};
// native 通知 js
export var Native2Js = function (params, callback) {
    params.params = params.params || {};
    var name = params.name;
    // 创建数组
    if (!Native2JsCallBack[name]) {
        Native2JsCallBack[name] = [];
    }
    Native2JsCallBack[name].push(callback);
    // 老版本是直接绑定在window上的，新版本借助 IGC_Native2Js（前端注入） 分发。
    window[name] = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        var json = {};
        if (Object.prototype.toString.call(arg[0]) === '[object Object]') {
            json = arg[0];
        }
        else {
            json = initResult[name] ? initResult[name].apply(initResult, arg) : {};
        }
        Native2JsCallBack[name].forEach(function (_callback) {
            if (typeof _callback === 'function') {
                try {
                    _callback(json);
                }
                catch (error) { }
            }
        });
    };
};
// 新增on绑定方法，与直接调用一致
Native2Js.on = function (name, callback) {
    Native2Js({
        name: name,
    }, callback);
};
// off解绑，不传参数则全部清除
Native2Js.off = function (name, callback) {
    if (!callback) {
        Native2JsCallBack[name] = [];
    }
    else if (Array.isArray(Native2JsCallBack[name]) && Native2JsCallBack[name].length && typeof callback === 'function') {
        Native2JsCallBack[name] = Native2JsCallBack[name].filter(function (_callback) { return _callback !== callback; });
    }
};
